module.exports = __webpack_public_path__ + "img/img6.4f8b2047.svg";